import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { AppLayoutModule } from "./layout/app.layout.module";
import { provideFirebaseApp, initializeApp } from "@angular/fire/app";
import { environment } from "src/environments/environment";
import { provideAuth, getAuth } from "@angular/fire/auth";
import { MessageService } from "primeng/api";
import { ToastModule } from "primeng/toast";
import { providePrimeNG } from "primeng/config";
import { definePreset } from "@primeuix/themes";
import Aura from "@primeuix/themes/aura";
import { CsrfInterceptor } from "./site/interceptors/csrf.interceptor";
import { PasswordExpiredInterceptor } from "./site/interceptors/password-expired.interceptor";

const AuraOrangePreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: "{orange.50}",
      100: "{orange.100}",
      200: "{orange.200}",
      300: "{orange.300}",
      400: "{orange.400}",
      500: "{orange.500}",
      600: "{orange.600}",
      700: "{orange.700}",
      800: "{orange.800}",
      900: "{orange.900}",
      950: "{orange.950}",
    },
  },
});

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    AppLayoutModule,
    ToastModule,
  ],
  bootstrap: [AppComponent],
  providers: [
    providePrimeNG({
      theme: {
        preset: AuraOrangePreset,
        options: {
          darkModeSelector: ".app-dark",
        },
      },
    }),
    provideFirebaseApp(() => initializeApp(environment.config)),
    provideAuth(() => getAuth()),
    MessageService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CsrfInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PasswordExpiredInterceptor,
      multi: true,
    },
  ],
})
export class AppModule {}
